<template>
    <div class="container-payment-plans">
        <div class="container-payment-plans-header">
            <div class="title">Cadastre os planos de pagamentos que estarão disponível para os caixas.</div>
        </div>

        <div class="container-payment-plans-name-percent-select">
            <div class="input-name-percent">
                <ui-input
                    v-model="tableValues.name"
                    label="Nome do plano"
                    placeholder="Ex. À vista"
                    type="text"
                    required
                />
            </div>

            <div class="input-name-percent">
                <ui-input
                    v-model="tableValues.discount_entrance"
                    label="Desconto:"
                    placeholder="0"
                    groupicon="fal fa-percent"
                    type="number"
                    required
                />
            </div>

            <div class="input-name-percent">
                <ui-input
                    v-model="tableValues.entrance"
                    label="Entrada:"
                    placeholder="0"
                    groupicon="fal fa-percent"
                    type="number"
                    required
                />
            </div>

            <!-- <div class="input-name-percent">
                <ui-input
                    v-model="tableValues.intermediation"
                    label="Intermediária:"
                    placeholder="0"
                    groupicon="fal fa-percent"
                    type="number"
                />
            </div> -->

            <div class="input-name-percent">
                <ui-input-money v-model="tableValues.bonus" group label="Bônus" required />
            </div>

            <div class="button-name-percent">
                <ui-button
                    :disabled="!canAdd"
                    :loading="loading"
                    design="md primary"
                    @click="addTableValues">
                    Adicionar
                </ui-button>
            </div>
        </div>

        <div class="container-payment-plans-table">
            <div class="payment-plans-table">
                <table-payment-plans :contents="data" />
            </div>
        </div>

        <div class="container-payment-plans-footer">
            <ui-engine :next="next" name-button="Avançar" />
        </div>

    </div>
</template>

<script>
	import { uiInput, uiInputMoney } from '@/components/ui/form'
	import { uiButton } from '@/components/ui/buttons'
	import { launchDay } from '@/services/axios'
	import uiEngine from '../engine'
	import tablePaymentPlans from './table-payment-plans'

	import { helpersMixin, utilMixin } from '@/mixins'

	import { mapActions, mapGetters } from 'vuex'

	const defaultDataTable = () => ({
		name: null,
		discount_entrance: null,
		entrance: null,
		intermediation: null,
		bonus: 0
	})

	export default {
		name: 'ui-launch-payment-plans',

		components: {
			uiInput,
			uiInputMoney,
			uiButton,
			uiEngine,
			tablePaymentPlans
		},

		mixins: [
			helpersMixin,
			utilMixin
		],

		data() {
			return {
				form: {},
				tableValues: { ...defaultDataTable() },
				data: [],
				next: { name: 'launch.management.create.commissioning', index: 4 },
				loading: false
			}
		},

		computed: {
			...mapGetters('launchDay', { config: 'getConfig' }),
			/**
			 * Computed property que define se o cadastro do plano de pagamento pode continuar
			 */
			canAdd() {
				return this.$mx_hasValue(this.tableValues.name) &&
					this.$mx_hasValue(this.tableValues.discount_entrance) &&
					this.$mx_hasValue(this.tableValues.entrance) &&
					this.$mx_hasValue(this.tableValues.bonus)
			}
		},

		mounted() {
			this.$root.$on('modal-msg-event-launch-plans-method-delete', (response) => {
				this.data.splice(response.data.index, 1)
				this.update()
			})

			this.loadForm()
		},

		methods: {
			...mapActions('launchDay', ['setConfig', 'setNextLoad']),
			/**
			 * Carrega os dados necessários para montar o formulário
			 */
			loadForm() {
				if (!this.config?.id) {
					this.$router.push({ name: 'launch.management.create.mainData' })
					return
				}

				this.form = { ...this.config }
				if (this.form.attributes.tableValues && this.isJSON(this.form.attributes.tableValues)) {
					this.data = [...JSON.parse(this.form.attributes.tableValues)]
				}
			},
			/**
			 * Adiciona um item na tabela de planos de pagamento
			 */
			addTableValues() {
				this.data.push(this.tableValues)
				this.update()
			},
			/**
			 * Atualiza o lançamento, adicionando mais um plano de pagamento
			 */
			update() {
				this.loading = true
				this.form.attributes.tableValues = JSON.stringify(this.data)
				launchDay.update('', this.form.id, this.form)
					.then(res => {
						this.$toastr.s(res.data.msg)
						this.tableValues = { ...defaultDataTable() }
					})
					.catch(error => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					})
					.finally(() => {
						this.loading = false
					})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>